import { Component, Output, ViewChild, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';


@Component({
  selector: 'cms-modal',
  templateUrl: './modal.component.html',
  styleUrls: [
    './modal.component.scss'
  ]
})

export class ModalComponent {
  @ViewChild('nModal') public nModal:ModalDirective;
  @Output() confirmDelete = new EventEmitter();
  @Output() goToList = new EventEmitter();

  modalType: string;
  content = {
    'title': '',
    'text': ''
  };

  constructor() {}

  showModal(message: any) {
    this.content = message;
    this.nModal.show();
  }

  hideModal() {
    this.nModal.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.component.ts